var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftChevron = function SvgLeftChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "leftChevron_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M24 24H0V0h24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#leftChevron_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.125 6.877a.72.72 0 0 1 .225.525.72.72 0 0 1-.225.525l-4.075 4.075 4.075 4.075a.72.72 0 0 1 .225.525.72.72 0 0 1-.225.525.72.72 0 0 1-.525.225.72.72 0 0 1-.525-.225l-4.5-4.5a.8.8 0 0 1-.188-.287.94.94 0 0 1 0-.675.8.8 0 0 1 .188-.288l4.5-4.5a.72.72 0 0 1 .525-.225q.3 0 .525.225"
  }))));
};
export default SvgLeftChevron;